import React, {Component} from 'react'
import * as moment from 'moment'
import {EventStyle} from './../styles'

export default class Event extends Component {
  state = {
    open: false
  }

  handlerClick = (e) => {
    e.preventDefault()
    this.setState({ open: !this.state.open })
  }

  getDayNumber = (date) => {
    return date.slice(8,10)
  }

  getDayWeeks = (date) => {
    const day = moment(date).day()
    const weeks = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    return weeks[day]
  }

  render() {
    const { 
      date_start, 
      date_end, 
      hour, 
      content_preview, 
      content_top, 
      content_bottom, 
      cover, 
      title
    } = this.props
    const { open } = this.state
    const now = moment().get('date')
    const max = moment().daysInMonth()
    return (
      <div className={`event ${EventStyle( cover )} flex`} onClick={this.handlerClick}>
        {date_start == date_end && (
          <div className="event-day">
            <div className="number">{this.getDayNumber(date_start)}</div>
            <div className="day">{this.getDayWeeks(date_start)}</div>
            {hour && <div className="hour">{hour}:00</div>}
          </div>
        )}

        {date_start != date_end && (
          <div className="event-day">
            <div className="number">{moment(date_start).format('MM-DD')}</div>
            <div className="day">to</div>
            <div className="number">{moment(date_end).format('MM-DD')}</div>
          </div>
        )}
        
        <div className="event-info">
          <div className="event-title">{ title }</div>
          {
            !open && <div className="event-description" dangerouslySetInnerHTML={{'__html': content_preview}} />
          }
          {
            open && (
              <div>
                { content_top && <div className="event-description" dangerouslySetInnerHTML={{'__html': content_top}} /> }
                { cover && <div className="event-picture"></div> }
                { content_bottom && <div className="event-description" dangerouslySetInnerHTML={{'__html': content_bottom}} /> }
              </div>
            )
          }
        </div>
        <div className="event-link">
          {!open && <span className="link">Read more</span>}
          {open && <span className="close"></span>}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Event.js